import Big from "big.js"
import * as z from "zod"

import { createEntityFor } from "@axtesys/react-tools"

import { ArticleGroupId } from "./ArticleGroup"
import { MainGroupId } from "./MainGroup"

export type ArticleId = string

export type SharedArticleFlags = {
  negativePrice: boolean
  zeroPriceAllowed: boolean
  discountBlocked: boolean
  detailsDirectAccess: boolean
  depositBacked: boolean
}
export type ArticleFlags = SharedArticleFlags & { variablePrice: boolean }

export type SharedArticle = {
  mainGroupId: MainGroupId
  articleGroupId: ArticleGroupId
  name: string
  price: Big
  depositArticleId?: ArticleId
  description?: string
}
export type Article = SharedArticle & {
  articleId: ArticleId
  taxRate: number
  flags: ArticleFlags

  barcodePrefix?: number
  number?: string
  barcodeNumbers?: string[]
}
export type ItemArticle = Omit<
  Article,
  "flags" | "description" | "barcodeNumbers"
> & { flags?: ArticleFlags }

export const ArticleFlagsEntity = createEntityFor<ArticleFlags>()
  .withSchema(
    z.object({
      negativePrice: z.boolean(),
      variablePrice: z.boolean(),
      zeroPriceAllowed: z.boolean(),
      discountBlocked: z.boolean(),
      detailsDirectAccess: z.boolean().default(false),
      depositBacked: z.boolean().default(false),
    }),
  )
  .serialize(data => data)
  .deserialize(json => json)

export const ArticleEntity = createEntityFor<Article>()
  .withSchema(
    z.object({
      articleId: z.string(),
      mainGroupId: z.string(),
      articleGroupId: z.string(),
      name: z.string(),
      taxRate: z.number(),
      price: z.string(),
      flags: ArticleFlagsEntity.schema,
      depositArticleId: z.ostring(),
      barcodePrefix: z.onumber(),
      number: z.ostring(),
      description: z.ostring(),
      barcodeNumbers: z.optional(z.array(z.string())),
    }),
  )
  .serialize(data => ({ ...data, price: data.price?.toString() }))
  .deserialize(json => ({ ...json, price: Big(json.price) }))

export const ItemArticleEntity = createEntityFor<ItemArticle>()
  .withSchema(
    z.object({
      articleId: z.string(),
      mainGroupId: z.string(),
      articleGroupId: z.string(),
      name: z.string(),
      taxRate: z.number(),
      price: z.string(),
      depositArticleId: z.ostring(),
      number: z.ostring(),
      flags: z.optional(ArticleFlagsEntity.schema),
    }),
  )
  .serialize(data => ({ ...data, price: data.price?.toString() }))
  .deserialize(json => ({ ...json, price: Big(json.price) }))
